import GiftItem from './GiftItem';

export default GiftItem;
